export interface RegistrationConfiguration {
    // allow registration of branches
    allowBranches: boolean;
    // allow special arrangement
    allowSpecialArrangement: boolean;
    // allow editing organization details
    allowOrganisationDetailEdits: boolean;
}
